import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ActiveSubstitution = {
  initiatorId: string;
  initiatorName: string | null;
  commonBusinessUnits: string[];
};

interface WorkAsState {
  activeSubstitution: ActiveSubstitution | null;
  setActiveSubstitution: (substitution: ActiveSubstitution) => void;
  clearActiveSubstitution: () => void;
}

export const useWorkAsStore = create<WorkAsState>()(
  persist(
    (set) => ({
      activeSubstitution: null,
      setActiveSubstitution: (substitution) => set({ activeSubstitution: substitution }),
      clearActiveSubstitution: () => set({ activeSubstitution: null }),
    }),
    {
      name: 'work-as-store',
    },
  ),
);
